// extracted by mini-css-extract-plugin
export var active_faq = "index-module--active_faq--39a34";
export var add_on = "index-module--add_on--0fc85";
export var add_ons_container = "index-module--add_ons_container--a1a9f";
export var add_ons_text = "index-module--add_ons_text--3a406";
export var bodyFont = "index-module--body-font--4a71d";
export var custom_list = "index-module--custom_list--dfb3e";
export var description = "index-module--description--2efaf";
export var faq = "index-module--faq--b0212";
export var pricing_list = "index-module--pricing_list--a0432";
export var pricing_section = "index-module--pricing_section--6c134";
export var solution_list = "index-module--solution_list--897c9";
export var split_text = "index-module--split_text--5d94e";
export var titleFont = "index-module--title-font--b02f6";
export var whats_included = "index-module--whats_included--a7472";